module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-09.2c303a9c.jpg";